import { environment } from "../../../environments/environment";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { OperacionesDelClienteJuridico, OperacionesDelClienteJuridicoData, InformacionPatrimonialJuridico, InformacionPatrimonialJuridicoData, VinculadaAlClienteJuridicoData, VinculadaAlClienteJuridico } from '../../views/register/form-complete/form-tree/interface/JuridicasInterface';

var apiRequests = `${environment.BACKEND_URL}/cliente_potencial`;
// var apiRequests = `${environment.BACKEND_URL}/archivo`;

@Injectable({
  providedIn: "root",
})
export class registerService {
  data = null;

btnAccesoFirmaJuridico: Boolean = false;

btnAccesoFirmaNatural: Boolean = false;

showBtnAccesoFirmaNatural () {
  this.btnAccesoFirmaNatural  = true;
}

showBtnAccesoFirmaJuridico () {
  this.btnAccesoFirmaJuridico  = true;
}


  constructor(private http: HttpClient) { }

  httpHeader = {
    headers: new HttpHeaders({
      // 'Content-Type': 'application/json',
      Authorization: "Basic " + btoa(localStorage.getItem("token_jwt")),
    }),
  };

  //TODO: Llevar metodo a un servicio diferente
  getDistritos(provincia: String): Observable<any> {

    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.get(apiRequests + "/ubigeo/distritos/" + provincia, {
      headers: headers,
    });

  }

  //TODO: Llevar metodo a un servicio diferente
  getPronvincias(departamento: String): Observable<any> {

    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.get(apiRequests + "/ubigeo/provincias/" + departamento, {
      headers: headers,
    });

  }

  //TODO: Llevar metodo a un servicio diferente
  getDepartamentos() {

    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.get(apiRequests + "/ubigeo/departamentos", {
      headers: headers,
    });

  }


  updateInformacionPatrimonialuridico(operacionesDelClienteJuridicoToUpdate: InformacionPatrimonialJuridicoData): Observable<InformacionPatrimonialJuridicoData> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.put<InformacionPatrimonialJuridicoData>(apiRequests + "/juridica/inf_patrimonial_fondos", operacionesDelClienteJuridicoToUpdate, {
      headers: headers,
    });
  }


  updateVinculadosAlCliente(vinculadosAlClienteToUpdate) {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.put(apiRequests + "/juridica/vinculados_al_cliente", vinculadosAlClienteToUpdate, {
      headers: headers,
    });

  }

  updateOperacionesDelClienteJuridico(operacionesDelClienteToUpdate: OperacionesDelClienteJuridicoData): Observable<OperacionesDelClienteJuridicoData> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.put<OperacionesDelClienteJuridicoData>(apiRequests + "/juridica/operaciones_cliente", operacionesDelClienteToUpdate, {
      headers: headers,
    });
  }


  registerUser(data): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");

    return this.http.post(apiRequests + "/cliente_base", data);
  }

  verifyCode(data): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");

    return this.http.put(apiRequests + "/cliente_base/verify_code", data);
  }

  getmoreaboutYou(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.get(apiRequests + "/saber_mas_de_ti", {
      headers: headers,
    });
  }

  estadodelFormulario(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.get(apiRequests + "/status", {
      headers: headers,
    });
  }

  moreaboutYou(data): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.put(apiRequests + "/saber_mas_de_ti", data, {
      headers: headers,
    });
  }

  editOneFormNatural(data): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.put(
      apiRequests + "/natural/identificacion_cliente",
      data,
      {
        headers: headers,
      }
    );
  }

  editTwoFormNatural(data): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.put(apiRequests + "/natural/actividad_cliente", data, {
      headers: headers,
    });
  }

  editTreeFormNatural(data): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.put(apiRequests + "/natural/operaciones_cliente", data, {
      headers: headers,
    });
  }

  editFourFormNatural(data): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.put(
      apiRequests + "/natural/inf_patrimonial_fondos",
      data,
      {
        headers: headers,
      }
    );
  }

  user;

  anexoOneNatural(data): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.put(
      apiRequests + "/natural/anexo_dj_residencia_fiscal",
      data,
      {
        headers: headers,
      }
    );
  }

  anexoTwoNatural(data): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.put(apiRequests + "/natural/anexo_dj_pep", data, {
      headers: headers,
    });
  }

  anexoTreeNatural(data): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.put(
      apiRequests + "/natural/anexo_dj_inversionista_institucional",
      data,
      {
        headers: headers,
      }
    );
  }


  ShowBtnAccederFirma(){

  }
  getOneFormNatural(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.get(apiRequests + "/natural/identificacion_cliente", {
      headers: headers,
    });
  }

  geTwoFormNatural(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.get(apiRequests + "/natural/actividad_cliente", {
      headers: headers,
    });
  }

  getTreeFormNatural(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.get(apiRequests + "/natural/operaciones_cliente", {
      headers: headers,
    });
  }

  getFourFormNatural(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.get(apiRequests + "/natural/inf_patrimonial_fondos", {
      headers: headers,
    });
  }

  getOneFormJuridico(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.get(apiRequests + "/juridica/identificacion_cliente", {
      headers: headers,
    });
  }

  getTwoFormJuridico(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.get(apiRequests + "/juridica/actividad_cliente", {
      headers: headers,
    });
  }


  // TODO: Borrar
  // getTreeFormJuridico(): Observable<any> {
  //   let headers = new HttpHeaders();
  //   headers = headers.set("Content-type", "application/json");
  //   headers = headers.set(
  //     "Authorization",
  //     "Bearer " + localStorage.getItem("tokenRegister")
  //   );

  //   return this.http.get(apiRequests + "/juridica/operaciones_cliente", {
  //     headers: headers,
  //   });
  // }

  getOperacionesDelClienteJuridico(): Observable<OperacionesDelClienteJuridico> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.get<OperacionesDelClienteJuridico>(apiRequests + "/juridica/operaciones_cliente", {
      headers: headers,
    });
  }


  getVinculadosAlCliente(): Observable<any> {

    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.get<any>(apiRequests + "/juridica/vinculados_al_cliente", {
      headers: headers,
    });

  }

  getInformacionPatrimonial(): Observable<InformacionPatrimonialJuridico> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.get<InformacionPatrimonialJuridico>(apiRequests + "/juridica/inf_patrimonial_fondos", {
      headers: headers,
    });
  }


  getFourFormJuridico(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.get(apiRequests + "/juridica/personas_autorizadas", {
      headers: headers,
    });
  }

  editOneFormJuridico(data): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.put(
      apiRequests + "/juridica/identificacion_cliente",
      data,
      {
        headers: headers,
      }
    );
  }

  editTwoFormJuridico(data): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.put(apiRequests + "/juridica/actividad_cliente", data, {
      headers: headers,
    });
  }

  editTreeFormJuridico(data): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.put(apiRequests + "/juridica/operaciones_cliente", data, {
      headers: headers,
    });
  }

  editFourFormJuridico(data): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.put(
      apiRequests + "/juridica/personas_autorizadas",
      data,
      {
        headers: headers,
      }
    );
  }

  anexoOneJuridico(data): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.put(
      apiRequests + "/juridica/anexo_dj_residencia_fiscal",
      data,
      {
        headers: headers,
      }
    );
  }

  anexoTwoJuridico(data): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.put(apiRequests + "/juridica/anexo_dj_pep", data, {
      headers: headers,
    });
  }

  anexoTreeJuridico(data): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );

    return this.http.put(
      apiRequests + "/juridica/anexo_dj_inversionista_institucional",
      data,
      {
        headers: headers,
      }
    );
  }


  //firma digital

  //abrir widget
  launchWidget(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );
    return this.http.get(apiRequests + "/launch-keynua", { headers: headers });
  }

  //verificar estado de la firma
  verifySignature(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("tokenRegister")
    );
    return this.http.get(apiRequests + "/verify/signature", { headers: headers });
  }

}
